module.exports = __webpack_public_path__ + "img/6-map.e86222a2.jpg";